import { render } from "./EmailSettings.vue?vue&type=template&id=6acd7db8&scoped=true"
import script from "./EmailSettings.vue?vue&type=script&lang=js"
export * from "./EmailSettings.vue?vue&type=script&lang=js"

import "./EmailSettings.vue?vue&type=style&index=0&id=6acd7db8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6acd7db8"]])

export default __exports__